<template>
  <div class="top-box">
    <div class="box">
      <div
        class="box-left"
        @click="onSkipPageFn"
      >
        <div class="homepage-img"><img src="@/assets/image/homepage.png" alt="" /></div>
        {{ title }}
      </div>
      <div class="box-rigth">
        <div class="right-box">
          <div class="zone-box" v-if="title === '在线编辑简历'">
            <div class="right-zone long" @click="resumePreview(1)">预览简历</div>
            <div class="right-zone long" @click="resumePreview(2)">诊断简历</div>
            <div class="right-zone" @click="resetForm">一键清空</div>
          </div>
          <el-popover placement="top" width="148" trigger="hover">
            <template #reference>
              <div class="user-info">
                <div
                  v-if="userInfo && userInfo.data && userInfo.data.avatar"
                  class="avatar-box"
                >
                  <img :src="userInfo.data.avatar" />
                </div>
                <div class="name-box">{{ userInfo.data.real_name || userInfo.data.nickname }}</div>
                <div class="more-box">
                  <img style="transform: rotate(90deg)" src="@/assets/image/箭头 (1).png" />
                </div>
              </div>
            </template>
            <div class="nav-box">
              <div class="item" @click="confirmBack">
                <img src="@/assets/image/me-icon1.png" />
                退出登录
              </div>
              <div class="item" @click="ensureFn">
                <img src="@/assets/image/out-icon1.png" />
                关闭应用
              </div>
              <div class="item">V1.5.0</div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    title: {
      type: String
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapMutations({
      removerContents: 'REMOVER_CONTENTS'
    }),
    // 退出登录按钮
    confirmBack() {
      this.removerContents()
      this.$router.push('/resume/login')
    },
    // 触发在线编辑的方法 预览和诊断简历
    resumePreview(figure) {
      this.$emit('resumePreview', figure)
    },
    // 触发在线编辑的一键清空
    resetForm() {
      this.$emit('resetForm')
    },
    // 跳转到首页
    onSkipPageFn() {
      if (this.title !== '首页') this.$router.push('/resume/index')
    },
    // 当用户点击确定退出
    ensureFn() {
      history.go(-history.length + 1)
    }
  }
}
</script>

<style lang="stylus" scoped>
.top-box
  position fixed
  left 0
  top 0
  width 100%
  height 60px
  background #0255fc
  box-shadow 0 4px 10px 0 rgba(196, 214, 245, 0.15)
  display flex
  justify-content center
  z-index 9999
  .box
    width 1200px
    height 100%
    display flex
    justify-content space-between
    align-items center
    .box-left
      display flex
      font-size 28px
      line-height 27px
      font-family Source Han Sans CN
      font-weight 500
      color #FFFFFF
      .homepage-img
        width 30px
        height 30px
        margin-right: 5px
    .box-left:hover
      cursor pointer
    .box-rigth
      .right-box
        display flex
        align-items center
        .user-info
          width: auto
          height: auto
          display: flex
          align-items: center
          cursor: pointer
          .avatar-box
            width: 28px
            height: 28px
            border-radius: 50%
            overflow: hidden
            img
              display: block
              width: 100%
              height: 100%
              object-fit: cover
          .name-box
            width: auto
            height: auto
            margin: 0 10px 0 8px
            line-height: 36px
            font-size: 14px
            font-weight: bold
            color: #fff
          .more-box
            width: 9px
            height: 9px
            img
              display: block
              width: 100%
              height: 100%
        .zone-box
          display flex
          .right-zone
            font-size 16px
            font-family PingFang SC
            font-weight 500
            color #FFFFFF
            position relative
            padding-right 14px
            margin-left 14px
          .right-zone.long:after
            content ''
            position absolute
            top 5px
            right 0
            height 14px
            border-right 1px solid #fff
            opacity 0.5
          .right-zone:hover
            cursor pointer
            text-decoration underline
.nav-box
  width auto
  height auto
  .item
    width 100%
    height auto
    padding 0 14px
    cursor pointer
    line-height 35px
    display flex
    align-items center
    justify-content center
    border-radius 4px
    color #333
    box-sizing border-box
    &:hover
      background-color rgb(235, 241, 250)
    img
      display block
      width 15px
      height 15px
      margin-right 6px
  .line
    width 100%
    height 1px
    margin 7px 0
    background-color #E8E9EB
</style>
